/**
 * «Зайнято» в застосунку (UX-19): тексти тимчасових відмов і таймер автоматичного повтору зміни.
 *
 * Сам повтор робить `api()` (platform/api.ts): зміна з тимчасовою відмовою чекає `Retry-After` і
 * повторюється раз з тим самим ключем. Тут — що бачить людина:
 * - поки зміна чекає, — тост «Забагато дій за короткий час. Повторюємо через 3 с…» з таймером,
 *   один на всі зміни, що чекають; зникає, коли дочекались усі (`watchBusy`, викликає main.tsx);
 * - повтор не допоміг або чекати задовго — `busyMessage(error)`: «… Спробуйте ще раз через 12 с»
 *   замість загального «не вдалося»; форма лишається з введеним.
 * Документ входу таймера не показує (там немає хоста тостів): кнопка лишається «виконується».
 */
import { states as t } from '../i18n/uk/states.ts';
import { dismissToast, toast } from '../ui/notify/store.ts';
import { onBusyWait, retryAfterOf } from './api.ts';

/** Текст тимчасової відмови з часом до повтору; `null` — це не тимчасова відмова. */
export function busyMessage(error: unknown): string | null {
  const wait = retryAfterOf(error);
  return wait === null ? null : t.busyLater((error as { code: string }).code, wait);
}

const BUSY_TOAST = 'busy-wait';

export function watchBusy(): () => void {
  let waiting = 0;
  let until = 0;
  let id: number | null = null;
  return onBusyWait((wait) => {
    waiting++;
    until = Math.max(until, wait.until);
    id = toast({
      key: BUSY_TOAST,
      text: t.busyWhy(wait.code),
      countdown: { until, text: t.busyRetrying },
    });
    return () => {
      waiting--;
      if (waiting > 0 || id === null) return;
      dismissToast(id);
      id = null;
      until = 0;
    };
  });
}
